<template>
  <div id="videocallSectionDyte" ref="videocallSectionDyte" :floating-mode="floatingMode" :is-maximized="isMaximized" :class="show ? 'show-videoconsult' : 'hide-videoconsult'" @mousedown="dragVideoCall">
    <dyte-meeting id="my-grid" class="dyte" :show-setup-screen="!isPsychologist"></dyte-meeting>
  </div>
</template>

<script>
import CustomButton from "@dytesdk/ui-kit-addons/custom-controlbar-button";
import {DyteClient} from "@dytesdk/web-core";
import {onMounted, ref, watch, computed, onUnmounted} from "vue";
import {useRoute} from 'vue-router';
import {useStore} from "vuex";
import {
  createDyteInstanceMeeting,
  setDyteInstanceMeeting,
  setMeetingEvents,
  eventsConstants,
} from '@/utils/dyteVideocallUtil';
import {registerAddons} from "@dytesdk/ui-kit";
import DyteVideoBackgroundTransformer from "@dytesdk/video-background-transformer";
import VideoBackground from "@dytesdk/ui-kit-addons/video-background";

export default {
  props: {
    roomName: {
      type: String,
      default: null
    },
    dyteToken: {
      type: String,
      default: null
    }
  },
  emits: ['videocallEnded', 'initVideocall'],
  setup(props, {emit}) {
    const route = useRoute();
    const store = useStore()
    var token = props.dyteToken
    const userName = computed(() => store.getters['auth/getLoggedUser'])
    const initVideoCall = computed(() => store.getters['getStartVideoCallDyte'])
    const dyteToken = computed(() => store.getters['getDyteToken'])
    const show = ref(false)
    const isPsychologist = computed(() => store.getters['auth/getLoggedUser']?.role_id === 2)

    const floatingMode = ref(false);
    const isMaximized = ref(false);
    var meeting = null
    var config = null
    var els;
    var hasFilterApplied = false
    var videoBackgroundTransformer;
    let activeMiddleware;
    const positions = ref({
      clientX: undefined,
      clientY: undefined,
      movementX: 0,
      movementY: 0
    });

    watch(initVideoCall, (value) => {

      show.value = value

      if (value) {
        token = dyteToken.value
        floatingMode.value = true
        init()
      }

    })

    const roomJoined = async (obj) => {
      //console.log('se unio a videollamada');
    }

    const roomLef = (obj) => {
      if (obj.state === 'left') {
        store.commit('setStartVideoCallDyte', false)
        store.commit('setStartVideoCall', false)
        emit("videocallEnded");
      }
    }

    const participantJoined = () => {
      // console.log("JOINED ")
      // console.log(meeting.participants.active)
    }

    const participantLeft = () => {
      // console.log("LEFT ")
      // console.log(meeting.participants.active)
    }

    const init = async () => {

      // console.log('ininciando videollamada');
      meeting = await createDyteInstanceMeeting(token);

      //Set current user name
      //await meeting.self.setName(userName.value.name);

      window.addEventListener('beforeunload', function (event) {
        leaveMeeting()
      })

      videoBackgroundTransformer = await DyteVideoBackgroundTransformer.init();

      els = document.getElementsByClassName('dyte');

      setDyteInstanceMeeting(meeting, els);

      //If floatingMode by default is true, its means that the user is a psichology and his videocall is init at float
      //If floatingMode by default is false, its means that the user is a client and his videocall is full screen by default. Client cant switch to floating mode and fullscreen.
      var confAddons
      if (floatingMode.value) {
        confAddons = addAddons(true, true, false)
      } else {
        confAddons = addAddons(true, false, false)
      }

      setConfiguration(confAddons)
      setStylesConfiguration()

      // meeting.self.on('screenShareUpdate', ({screenShareEnabled, screenShareTracks}) => {
      //
      //       console.log(screenShareEnabled)
      //       console.log(screenShareTracks)
      //
      //       if (screenShareEnabled) {
      //         // handle screen share start
      //         console.log("ENNN1")
      //       } else {
      //         // handle stop screen share
      //         console.log("ENNN2")
      //       }
      //
      //     }
      //
      // );


      setMeetingEvents(meeting, [
        [eventsConstants.ROOM_JOINED, roomJoined],
        [eventsConstants.ROOM_LEFT, roomLef],
      ], [
        ["participantJoined", participantJoined],
        ["participantLeft", participantLeft]
      ]);

    }

    const dragVideoCall = (event) => {

      if (floatingMode.value && !isMaximized.value) {

        // get the mouse cursor position at startup:
        positions.value.clientX = event.clientX
        positions.value.clientY = event.clientY

        document.onmousemove = elementDrag
        document.onmouseup = closeDragElement
      }

    }

    const elementDrag = (event) => {

      const videocallSectionDyte = document.getElementById("videocallSectionDyte")

      positions.value.movementX = positions.value.clientX - event.clientX
      positions.value.movementY = positions.value.clientY - event.clientY
      positions.value.clientX = event.clientX
      positions.value.clientY = event.clientY

      //Set the element's new position:
      const yPosition = (videocallSectionDyte.offsetTop - positions.value.movementY)
      const xPosition = (videocallSectionDyte.offsetLeft - positions.value.movementX)

      videocallSectionDyte.style.top = yPosition + 'px'
      videocallSectionDyte.style.left = xPosition + 'px'

    }

    const closeDragElement = () => {
      document.onmouseup = null
      document.onmousemove = null
    }

    const addAddons = (blurButton = true, fullScreenButton = true, minimizedScreenButton = false) => {

      var addons = new Array();

      if (blurButton) {
        addons.push(new CustomButton({
          position: 'center', // left | center | right
          label: 'Desenfocar',
          onClick: () => setBackgroundEffect(),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="48px" width="48px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"/></svg>'
        }))
      }

      if (fullScreenButton) {
        addons.push(new CustomButton({
          position: 'left', // left | center | right
          label: 'Pantalla completa',
          onClick: () => setFullScreen(true),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M4.5 5.75c0-.69.56-1.25 1.25-1.25h2a.75.75 0 0 0 0-1.5h-2A2.75 2.75 0 0 0 3 5.75v2a.75.75 0 0 0 1.5 0v-2ZM4.5 18.25c0 .69.56 1.25 1.25 1.25h2a.75.75 0 0 1 0 1.5h-2A2.75 2.75 0 0 1 3 18.25v-2a.75.75 0 0 1 1.5 0v2ZM18.25 4.5c.69 0 1.25.56 1.25 1.25v2a.75.75 0 0 0 1.5 0v-2A2.75 2.75 0 0 0 18.25 3h-2a.75.75 0 0 0 0 1.5h2ZM19.5 18.25c0 .69-.56 1.25-1.25 1.25h-2a.75.75 0 0 0 0 1.5h2A2.75 2.75 0 0 0 21 18.25v-2a.75.75 0 0 0-1.5 0v2Z" fill="currentColor"/></svg>'
        }))
      }

      if (minimizedScreenButton) {
        addons.push(new CustomButton({
          position: 'left', // left | center | right
          label: 'Salir de pantalla completa',
          onClick: () => setFullScreen(false),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.5 3.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 0 0 1.5h2.5A2.25 2.25 0 0 0 8.5 6.25v-2.5ZM8.5 20.25a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 1 0-1.5h2.5a2.25 2.25 0 0 1 2.25 2.25v2.5ZM16.25 3a.75.75 0 0 0-.75.75v2.5a2.25 2.25 0 0 0 2.25 2.25h2.5a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 0-.75-.75ZM15.5 20.25a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 0 0-1.5h-2.5a2.25 2.25 0 0 0-2.25 2.25v2.5Z" fill="currentColor"/></svg>'
        }))
      }

      const confAddons = registerAddons(addons, meeting);

      return confAddons;

    }

    const setFullScreen = (toggleFullScreen) => {

      //Toogle button to set full screen or exit full screen
      var confAddons

      if (!toggleFullScreen) {

        floatingMode.value = true
        confAddons = addAddons(true, true, false)

      } else {

        floatingMode.value = false
        confAddons = addAddons(true, false, true)

      }

      //confAddons.styles['dyte-fullscreen-toggle'] = {'display': 'none'}
      //confAddons.styles['div#video-container'] = {'width': '100% !important', 'max-width': '100% !important'}
      //confAddons.styles['dyte-screenshare-view'] = {'background': 'red'}

      setConfiguration(confAddons)
      setStylesConfiguration()

    }

    const setConfiguration = (confAddons) => {

      for (const el of els) {
        el.config = confAddons;
        el.showSetupScreen = false;
      }

    }

    const setStylesConfiguration = () => {

      const el = els[0]

      el.config.styles['dyte-fullscreen-toggle'] = {display: 'none'}

    }

    const setBackgroundEffect = async () => {

      if (!hasFilterApplied) {
        activeMiddleware = await videoBackgroundTransformer.createBackgroundBlurVideoMiddleware(7);
        await meeting.self.addVideoMiddleware(activeMiddleware);
        hasFilterApplied = true
      } else {
        await meeting.self.removeVideoMiddleware(activeMiddleware);
        hasFilterApplied = false
      }

    }

    const leaveMeeting = async () => {

      if (meeting !== null) {
        await meeting.leaveRoom()
      }

    }

    onMounted(() => {

          //If roomName prop is received, it means that videocall is called from external url (no internal)
          if (props.roomName != null) {
            show.value = true
            init()
          }

        }
    )

    onUnmounted(() => {
      leaveMeeting()
    })

    return {
      show,
      config,
      floatingMode,
      isMaximized,
      dragVideoCall,
      isPsychologist
    }
  }
}
</script>


<style lang="scss">

#my-grid {
  position: relative !important;
}

#videocallSectionDyte[floating-mode=true] {
  background: #292929;
  position: absolute;
  z-index: 9999;
  bottom: 0;
  right: 0;
  height: 440px;
  width: 650px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 50%);
  border-radius: 10px;

}

#videocallSectionDyte[floating-mode="true"] {
  border-radius: 0 !important;
  overflow: hidden;
}

#videocallSectionDyte[floating-mode=false] {
  background: #292929;
  position: absolute;
  z-index: 9999;
  top: 0 !important;
  right: 0 !important;
  left: 0 !important;
  height: 100vh;
  width: 100%;
}


</style>
